/** Nippon Center Pakistan — public build-time env (NEXT_PUBLIC_NCP_*). */

export const NCP_RECAPTCHA_SITE_KEY =
  process.env.NEXT_PUBLIC_NCP_RECAPTCHA_SITE_KEY || ''

export const NCP_CONTACT_ENDPOINT =
  process.env.NEXT_PUBLIC_NCP_CONTACT_ENDPOINT || ''

export const NCP_RECAPTCHA_ENABLED =
  Boolean(NCP_RECAPTCHA_SITE_KEY) &&
  NCP_RECAPTCHA_SITE_KEY !== 'YOUR_NCP_RECAPTCHA_SITE_KEY'

/**
 * Local-only form testing flag from .env.local.
 * Never set in staging/production CI.
 */
export const NCP_LOCAL_FORM_BYPASS =
  process.env.NEXT_PUBLIC_NCP_LOCAL_FORM_BYPASS === '1'
